import {CheckedValue} from '../../../../../../../components/ToggleButton/enum';

export const transformConditionOperator = (value: boolean) => {
    return !value ? CheckedValue.left : CheckedValue.right;
};
